import * as React from 'react';
import { IMapCoordinates, IMapGeoObject } from '@cian/frontend-newbuilding-map-component';
import * as ReactDOMServer from 'react-dom/server';
import { getPinSize } from './getPinSize';
import { MapPin } from '../../../components/MapPin';
import { EInfrastructureView, TInfrastructureType } from '../../../types/map';
import { IMainPromoPin } from '../../../types/newbuilding/mainPromoPin';

interface IGetGeoObjectOptions {
  name: TInfrastructureType;
  coordinates: IMapCoordinates;
  id: string;
  mainPromoPin?: IMainPromoPin | null;
  view?: EInfrastructureView;
}

export const getGeoObject = ({
  name,
  coordinates,
  id,
  mainPromoPin,
  view = EInfrastructureView.ExistingObject,
}: IGetGeoObjectOptions): IMapGeoObject => {
  const size = getPinSize({ name, mainPromoPin });
  const color = view === EInfrastructureView.FutureObject ? 'green' : 'blue';

  const geoObject: IMapGeoObject = {
    type: 'Point',
    name,
    options: {
      coordinates,
      html: ReactDOMServer.renderToStaticMarkup(<MapPin type={name} mainPromoPin={mainPromoPin} color={color} />),
      id,
      width: size,
      height: size,
    },
  };

  if (name !== 'main') {
    geoObject.options.yOffset = -size / 2;
  }

  return geoObject;
};

type TCoordinates = [number, number] | number[];

interface IGetPolygonGeoObjectOptions {
  name: TInfrastructureType;
  coordinates: TCoordinates[];
  id: string;
}

export const getPolygonGeoObject = ({ name, coordinates, id }: IGetPolygonGeoObjectOptions): IMapGeoObject => {
  return {
    type: 'Polygon',
    name,
    options: {
      coordinates: [coordinates],
      id,
    },
  };
};

interface IGetLineStringGeoObjectOptions {
  name: TInfrastructureType;
  coordinates: IMapCoordinates[];
  id: string;
}

export const getLineStringGeoObject = ({ name, id, coordinates }: IGetLineStringGeoObjectOptions): IMapGeoObject => {
  return {
    type: 'LineString',
    name,
    options: {
      coordinates: coordinates.map(({ lng, lat }) => [lng, lat]),
      id,
    },
  };
};
